import { render, staticRenderFns } from "./CommonEstablishmentsComp.vue?vue&type=template&id=5f9bd126&scoped=true"
import script from "./CommonEstablishmentsComp.vue?vue&type=script&lang=js"
export * from "./CommonEstablishmentsComp.vue?vue&type=script&lang=js"
import style0 from "./CommonEstablishmentsComp.vue?vue&type=style&index=0&id=5f9bd126&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f9bd126",
  null
  
)

/* custom blocks */
import block0 from "./CommonEstablishmentsComp.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports